import {
  Button,
  Checkbox,
  HStack,
  Input,
  Popover,
  Portal,
  Separator,
  Text,
  VStack,
} from '@chakra-ui/react'
import { LuListFilter } from 'react-icons/lu'
import type { DashboardFilter } from '../domain/types'
import { useState } from 'react'

export type ServiceBillingStatusFilter = {
  pendingApproval: boolean
  approved: boolean
  rejected: boolean
}

type Props = {
  filter: DashboardFilter
  draftStatusFilter: ServiceBillingStatusFilter
  draftDateFrom: string
  draftDateTo: string
  hasActiveFilter?: boolean
  onChangeStatusFilter: (next: ServiceBillingStatusFilter) => void
  onChangeDateFrom: (value: string) => void
  onChangeDateTo: (value: string) => void
  onApply: () => void
}

export function ServiceBillingFilterPopover({
  filter,
  draftStatusFilter,
  draftDateFrom,
  draftDateTo,
  hasActiveFilter = false,
  onChangeStatusFilter,
  onChangeDateFrom,
  onChangeDateTo,
  onApply,
}: Props) {
  const showStatusFilter = filter === 'ALL' || filter === 'ARCHIVE'
  const isArchiveFilter = filter === 'ARCHIVE'
  const [open, setOpen] = useState(false)

  return (
    <Popover.Root
      open={open}
      onOpenChange={e => setOpen(e.open)}
      positioning={{ placement: 'bottom-end', gutter: 8 }}
    >
      <Popover.Trigger asChild>
        <Button
          variant={hasActiveFilter ? 'solid' : 'subtle'}
          colorPalette={hasActiveFilter ? 'teal' : 'gray'}
          size="sm"
        >
          <HStack gap={2}>
            <LuListFilter />
            <Text>Filter</Text>
          </HStack>
        </Button>
      </Popover.Trigger>

      <Portal>
        <Popover.Positioner>
          <Popover.Content borderRadius="2xl" p="4" minW="320px">
            <Popover.Body p="0">
              <VStack align="stretch" gap="4">
                {showStatusFilter && (
                  <>
                    <VStack align="stretch" gap="3">
                      <Text fontWeight="700">Status</Text>

                      {!isArchiveFilter && (
                        <Checkbox.Root
                          checked={draftStatusFilter.pendingApproval}
                          onCheckedChange={e =>
                            onChangeStatusFilter({
                              ...draftStatusFilter,
                              pendingApproval: !!e.checked,
                            })
                          }
                        >
                          <Checkbox.HiddenInput />
                          <Checkbox.Control />
                          <Checkbox.Label>Wartet auf Freigabe</Checkbox.Label>
                        </Checkbox.Root>
                      )}

                      <Checkbox.Root
                        checked={draftStatusFilter.approved}
                        onCheckedChange={e =>
                          onChangeStatusFilter({
                            ...draftStatusFilter,
                            approved: !!e.checked,
                          })
                        }
                      >
                        <Checkbox.HiddenInput />
                        <Checkbox.Control />
                        <Checkbox.Label>Freigegeben</Checkbox.Label>
                      </Checkbox.Root>

                      <Checkbox.Root
                        checked={draftStatusFilter.rejected}
                        onCheckedChange={e =>
                          onChangeStatusFilter({
                            ...draftStatusFilter,
                            rejected: !!e.checked,
                          })
                        }
                      >
                        <Checkbox.HiddenInput />
                        <Checkbox.Control />
                        <Checkbox.Label>Abgelehnt</Checkbox.Label>
                      </Checkbox.Root>
                    </VStack>

                    <Separator />
                  </>
                )}

                <VStack align="stretch" gap="3">
                  <Text fontWeight="700">Zeitraum</Text>

                  <Input
                    type="date"
                    value={draftDateFrom}
                    onChange={e => onChangeDateFrom(e.target.value)}
                    placeholder="Anfangsdatum auswählen"
                  />

                  <Input
                    type="date"
                    value={draftDateTo}
                    onChange={e => onChangeDateTo(e.target.value)}
                    placeholder="Enddatum auswählen"
                  />
                </VStack>

                <Button
                  colorPalette="teal"
                  borderRadius="xl"
                  onClick={() => {
                    onApply()
                    setOpen(false)
                  }}
                >
                  Anwenden
                </Button>
              </VStack>
            </Popover.Body>
          </Popover.Content>
        </Popover.Positioner>
      </Portal>
    </Popover.Root>
  )
}
